import React from 'react';
import connect from 'react-redux/es/connect/connect';
import ParticipantStrip from '../../ParticipantStrip/videoRoom/ParticipantStrip';
import { styled } from '@material-ui/core/styles';
import MainParticipant from '../../MainParticipant/videoRoom/MainParticipant';

const Container = styled('div')({
  position: 'relative',
  height: '100%',
});

const MainParticipantContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: theme.sidebarWidth,
  right: 0,
  top: 0,
  bottom: 0,
  '& > div': {
    height: '100%'
  },
}));

class Room extends React.Component {
  render(){

    const { therapists, muteUnmuteAllParticipants,match, muteUnmuteParticipant, showMute, room, currentUser, guestMobileNumber, patient } = this.props;
		const {  activeCallHistory } = therapists;
    const {  participants } = patient;

    const { params } = match;
    return (
      <Container>
        <ParticipantStrip activeCalls={activeCallHistory} 
                          showMute={showMute}
                          room={room}
                          params={params}
                          participantList={participants}
                          guestMobileNumber={guestMobileNumber}
                          currentUser={currentUser}
                          muteUnmuteParticipant={muteUnmuteParticipant}
                          muteUnmuteAllParticipants={muteUnmuteAllParticipants} />
        <MainParticipantContainer>
          <div className="vid-screen">
          <MainParticipant activeCalls={activeCallHistory} currentUser={currentUser}/>
          </div>
        </MainParticipantContainer>
      </Container>
    );
  }
}


function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(Room);
